





































import { Component, Vue } from "vue-property-decorator";

import ENV from '@/environment';

@Component({})
export default class How extends Vue {

  content = {};
  env = ENV;

  mounted() {
    if (this.env.REGION === 'by') {
      this.content = this.contentBy;
    } else {
      this.content = this.contentRu;
    }
  }

  contentRu = {
    title: 'что может твой проездной',
    details1: 'Есть Проездные на несколько часов, а есть на несколько дней. Выбирай подходящий.',
    details2: 'До окончания срока действия Проездного для тебя будет доступна фиксированная стоимость минуты на все автомобили класса Эконом и Комфорт, в зависимости от выбранного пакета.',
  };
  contentBy = {
    title: 'что может твой проездной',
    details1: 'В каждый Проездной включен свой пакет минут на несколько часов или на 1, 3, 30 дней. Выбирай любой в зависимости от твоих задач.',
    details2: 'Цена фиксирована и дешевле, чем на минутном тарифе. А главное: можно арендовать не только эконом, но и комфорт-класс.',
  };
}
